<template>
    <div class="pt-card" :class="shadow ? 'is-' + shadow + '-shadow' : 'is-always-shadow'">
        <div v-if="$slots.header || header" class="pt-card__header">
            <slot name="header">{{ header }}</slot>
        </div>
        <div class="pt-card__body" :style="bodyStyle">
            <slot></slot>
        </div>
    </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'PtCard',
    props: {
        header: {
            type: String,
            default: '',
        },
        bodyStyle: {
            type: [String, Object, Array],
            default: '',
        },
        shadow: {
            type: String,
            default: '',
        },
    },
});
</script>

<style lang="scss" src="../style/card.scss"></style>
